import { ClipboardList, KeyRound, Package, ShoppingBag, ShoppingCart, UserRound, Users } from "lucide-react";

export const IconHelper = (name: any) => {
  switch (name) {
    case "shop":
      return <ShoppingBag size={16} />;
    case "cart":
      return <ShoppingCart size={16} />;
    case "orders":
    case "admin-orders":
      return <ClipboardList size={16} />;
    case "products":
      return <Package size={16} />;
    case "users":
      return <Users size={16} />;
    case "account":
      return <UserRound size={16} />;
    case "api-keys":
      return <KeyRound size={16} />;
    default:
      return <ShoppingBag size={16} />;
  }
};
